import React, { useState, useEffect, useContext  } from "react";
import axios from "axios";
import { AuthContext } from "../Components/AuthContext";
import eyeIcon from '../Images/view.png';
import eyeOffIcon from '../Images/hide.png';

const Profile = ({ token }) => {
  const { setUserData } = useContext(AuthContext);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "********", // Dummy password display
  });
  const [profileImage, setProfileImage] = useState(null);
  const [imageFile, setImageFile] = useState(null); // For uploading image
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null); // To handle errors while fetching
  const [showPopup, setShowPopup] = useState(false); // To display success popup
  const [showPasswordPopup, setShowPasswordPopup] = useState(false); // Password Popup

  const [passwordData, setPasswordData] = useState({
    current_password: "",
    password: "",
    password_confirmation: "",
  });
  const [passwordError, setPasswordError] = useState(null); // Error for password update
  const [passwordSuccess, setPasswordSuccess] = useState(false); 

const [showCurrentPassword, setShowCurrentPassword] = useState(false);
const [showNewPassword, setShowNewPassword] = useState(false);
const [showConfirmPassword, setShowConfirmPassword] = useState(false);

// Toggle functions
const toggleCurrentPassword = () => setShowCurrentPassword(!showCurrentPassword);
const toggleNewPassword = () => setShowNewPassword(!showNewPassword);
const toggleConfirmPassword = () => setShowConfirmPassword(!showConfirmPassword);
  // Fetch user data from API when component mounts
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get(
          "https://backend.printtrio.co.uk/api/profile/get-user-data",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.success) {
          const userData = response.data.data;

          // Populate state with API response
          setFormData({
            firstName: userData.first_name || "",
            lastName: userData.last_name || "",
            email: userData.email || "",
            phoneNumber: userData.phone_number || "",
            password: "********", // Keep password hidden
          });

          setProfileImage(userData.image); // Set profile image URL
        } else {
          setError("Failed to fetch user data.");
        }
      } catch (err) {
        console.error("Error fetching user data:", err);
        setError("An error occurred while fetching user data.");
      }
    };

    fetchUserData();
  }, [token]); // Run this effect when `token` changes

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file); // Save file for upload
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfileImage(reader.result); // Update preview of the uploaded image
      };
      reader.readAsDataURL(file);
    }
  };

  const triggerFileInput = () => {
    document.getElementById("fileInput").click();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);
  
    const formDataToSend = new FormData();
    formDataToSend.append("first_name", formData.firstName);
    formDataToSend.append("last_name", formData.lastName);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("phone_number", formData.phoneNumber);
  
    if (imageFile) {
      formDataToSend.append("image", imageFile);
    }
  
    try {
      const response = await axios.post(
        "https://backend.printtrio.co.uk/api/profile/update-user-data",
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      console.log("API Response Data:", response.data);
  
      if (response.data.success) {
        // Since API doesn't return updated data, use the current formData
        setUserData({
          firstName: formData.firstName,
          lastName: formData.lastName,
          image: profileImage || "",
        });
  
        // Update localStorage for persistence
        localStorage.setItem("firstName", formData.firstName);
        localStorage.setItem("lastName", formData.lastName);
        localStorage.setItem("image", profileImage || "");
  
        setShowPopup(true); // Show success popup
      } else {
        setError(response.data.errors || "Failed to update profile.");
      }
    } catch (err) {
      console.error("Error updating profile:", err);
      setError(
        err.response?.data?.errors || "An error occurred while updating the profile."
      );
    } finally {
      setIsSubmitting(false);
    }
  };
  
  
  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordData({ ...passwordData, [name]: value });
  };
  
  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setPasswordError(null);
    setPasswordSuccess(false);

     // Password validation regex
  const uppercaseRegex = /[A-Z]/;
  const lowercaseRegex = /[a-z]/;
  const digitRegex = /\d/;
  const specialCharRegex = /[@$!%*?&]/;

  if (passwordData.password.length < 8) {
    setPasswordError("New password must be at least 8 characters long.");
    return;
  } else if (!uppercaseRegex.test(passwordData.password)) {
    setPasswordError("New password must include at least one uppercase letter.");
    return;
  } else if (!lowercaseRegex.test(passwordData.password)) {
    setPasswordError("New password must include at least one lowercase letter.");
    return;
  } else if (!digitRegex.test(passwordData.password)) {
    setPasswordError("New password must include at least one digit.");
    return;
  } else if (!specialCharRegex.test(passwordData.password)) {
    setPasswordError("New password must include at least one special character (@$!%*?&).");
    return;
  }

  if (passwordData.password !== passwordData.password_confirmation) {
    setPasswordError("Passwords do not match.");
    return;
  }

    try {
      const response = await axios.post(
        "https://backend.printtrio.co.uk/api/profile/password",
        {
          current_password: passwordData.current_password,
          password: passwordData.password,
          password_confirmation: passwordData.password_confirmation,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        setPasswordSuccess(true); // Show success state
        setPasswordData({
          current_password: "",
          password: "",
          password_confirmation: "",
        });
      } else {
        setPasswordError(response.data.errors || "Failed to update password.");
      }
    } catch (err) {
      console.error("Error updating password:", err);
      setPasswordError(
        err.response?.data?.errors || "An error occurred while updating password."
      );
    }
  };


  return (
    <div className="flex-grow p-10 bg-white mt-[3%] mb-[3%] mx-[5%]">
      <div className="p-8 bg-white">
        <h2 className="text-2xl font-semibold mb-6 text-gray-800">Your Details</h2>

        {/* Display Error if API call fails */}
        {error && (
  <div className="text-red-500 mb-4 w-full">
    <ul>
      {Object.keys(error).map((key) => (
        <li key={key}>
          {error[key]}
        </li>
      ))}
    </ul>
  </div>
)}



        <div className="flex flex-col md:flex-row items-start space-x-0 md:space-x-8">
          {/* Profile Image */}
          <div
            className="w-24 h-24 rounded-full bg-gray-200 flex items-center justify-center overflow-hidden cursor-pointer"
            onClick={triggerFileInput}
          >
            {profileImage ? (
              <img
                src={profileImage}
                alt="Profile"
                className="w-full h-full object-cover"
              />
            ) : (
              <span className="text-gray-400">Select Pic</span>
            )}
          </div>
          <input
            type="file"
            id="fileInput"
            accept="image/*"
            onChange={handleImageChange}
            className="hidden"
          />

          {/* Form */}
          <form onSubmit={handleSubmit} className="flex-1 space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-7">
              <div>
                <label className="block text-gray-700 mb-2">First Name*</label>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  placeholder="Enter your first name"
                  className="mt-1 block w-full border border-gray-300 rounded-md p-2"
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 mb-2">Last Name*</label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  placeholder="Enter your last name"
                  className="mt-1 block w-full border border-gray-300 rounded-md p-2"
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 mb-2">Email*</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email address"
                  className="mt-1 block w-full border border-gray-300 rounded-md p-2"
                  required
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-gray-700 mb-2">Phone Number*</label>
                <input
                  type="text"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  placeholder="+44 Enter your phone number"
                  className="mt-1 block w-full border border-gray-300 rounded-md p-2"
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 mb-2">Password*</label>
                <div className="">
                  <input
                    type="password"
                    name="password"
                    value={formData.password}
                    readOnly
                    className="mt-1 block w-full border border-gray-300 rounded-md p-2"
                  />
                </div>
                <span 
                className="block mt-1 text-pink-500 cursor-pointer text-sm"
                onClick={() => setShowPasswordPopup(true)}
                >
                  Change Password
                </span>
              </div>
            </div>

            <div className="flex items-center space-x-4 mt-8">
              <button
                type="submit"
                className={`bg-pink-500 text-white px-6 py-2 rounded-full hover:bg-pink-600 ${
                  isSubmitting ? "opacity-50 cursor-not-allowed" : ""
                }`}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Saving..." : "Save"}
              </button>
              <button
                type="button"
                className="bg-gray-300 text-gray-700 px-6 py-2 rounded-full hover:bg-gray-400"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Success Popup */}
      {showPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg text-center">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Success!</h2>
            <p className="text-gray-600 mb-6">Profile updated successfully.</p>
            <button
              onClick={() => setShowPopup(false)}
              className="bg-pink-500 text-white px-6 py-2 rounded-full hover:bg-pink-600"
            >
              OK
            </button>
          </div>
        </div>
      )}

       {/* Change Password Popup */}
       {showPasswordPopup && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white p-6 rounded-lg shadow-md w-[90%] max-w-lg">
      <h3 className="text-lg font-semibold mb-4">Change Password</h3>

      {/* Render Errors */}
      {passwordError && (
        <div className="text-red-500 mb-4">
          {typeof passwordError === "object" ? (
            <ul>
              {Object.entries(passwordError).map(([key, value]) => (
                <li key={key}>
                  <strong>{key.replace("_", " ")}:</strong> {value}
                </li>
              ))}
            </ul>
          ) : (
            <p>{passwordError}</p>
          )}
        </div>
      )}

      {/* Render Success Message */}
      {passwordSuccess && <p className="text-green-500">Password updated successfully.</p>}

      {/* Password Form */}
      <form onSubmit={handlePasswordSubmit} className="space-y-4">
      <div className="relative">
        <input
          type={showCurrentPassword ? "text" : "password"}
          name="current_password"
          placeholder="Current Password"
          value={passwordData.current_password}
          onChange={handlePasswordChange}
          className="block w-full border p-2 rounded"
          required
        />
        <button
    type="button"
    onClick={toggleCurrentPassword}
    className="absolute inset-y-0 right-3 flex items-center text-gray-600"
  >
    <img
      src={showCurrentPassword ? eyeOffIcon : eyeIcon} // Switch icons
      alt="Toggle Password Visibility"
      className="h-6 w-6"
    />
  </button>
</div>
<div className="relative">
        <input
          type={showNewPassword ? "text" : "password"}
          name="password"
          placeholder="New Password"
          value={passwordData.password}
          onChange={handlePasswordChange}
          className="block w-full border p-2 rounded"
          required
        />
         <button
    type="button"
    onClick={toggleNewPassword}
    className="absolute inset-y-0 right-3 flex items-center text-gray-600"
  >
    <img
      src={showNewPassword ? eyeOffIcon : eyeIcon}
      alt="Toggle Password Visibility"
      className="h-6 w-6"
    />
  </button>
        </div>
        <div className="relative">
        <input
          type={showConfirmPassword ? "text" : "password"}
          name="password_confirmation"
          placeholder="Confirm Password"
          value={passwordData.password_confirmation}
          onChange={handlePasswordChange}
          className="block w-full border p-2 rounded"
          required
        />
         <button
    type="button"
    onClick={toggleConfirmPassword}
    className="absolute inset-y-0 right-3 flex items-center text-gray-600"
  >
    <img
      src={showConfirmPassword ? eyeOffIcon : eyeIcon}
      alt="Toggle Password Visibility"
      className="h-6 w-6"
    />
  </button>
</div>
        <div className="flex justify-end space-x-4">
          <button
            type="button"
            onClick={() => setShowPasswordPopup(false)}
            className="bg-gray-300 px-4 py-2 rounded"
          >
            Cancel
          </button>
          <button type="submit" className="bg-pink-500 text-white px-4 py-2 rounded">
            Update
          </button>
        </div>
      </form>
    </div>
  </div>
)}



    </div>
  );
};

export default Profile;
